import {getFileVerification} from '@/services/fileUploadService'
import {uploadFileService} from '@/services/uploadFile'
import {useState} from 'react'

export const useFileUpload = () => {
  const [isUpdating, setUpdating] = useState(false)
  const [progress, setProgress] = useState(0)
  const [fileUploadError, setFileUploadError] = useState('')
  const onUploadProgress = progressEvent => {
    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    setProgress(progress)
  }

  const onUploadFile = (file, onCallback, params = {}) => {
    const formData = new FormData()
    const {fileType, templateType = 'product', adfFlag = true} = params
    formData.append('file', file)
    if (!fileType) {
      setFileUploadError('Upload Error')
      return
    }
    formData.append('fileType', fileType)

    setUpdating(true)
    uploadFileService({formData, onUploadProgress}, templateType, adfFlag)
      .then(response => {
        onCallback(response)
        setUpdating(false)
        setProgress(0)
        setFileUploadError('')
      })
      .catch(error => {
        const errMsg = error?.response?.data?.errorMessage || error?.message || 'An unknown error occurred'
        setUpdating(false)
        setProgress(0)
        setFileUploadError(errMsg)
      })
  }

  const fileVerification = async (file, uploadFor) => {
    const formData = new FormData()
    formData.append('file', file)
    return getFileVerification(formData, uploadFor)
  }
  const uploadFile = async (file, uploadFor) => {
    const formData = new FormData()
    formData.file = file
    return getFileVerification(formData, uploadFor, onUploadProgress)
  }

  return {
    onUploadFile,
    isUpdating,
    progress,
    fileUploadError,
    setFileUploadError,
    fileVerification,
    uploadFile,
  }
}
